import * as React from "react";
const SvgCoins = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6667 8.75C11.6667 9.90059 9.8012 10.8333 7.50001 10.8333C5.19882 10.8333 3.33334 9.90059 3.33334 8.75M11.6667 8.75C11.6667 7.59941 9.8012 6.66667 7.50001 6.66667C5.19882 6.66667 3.33334 7.59941 3.33334 8.75M11.6667 8.75V15.8333C11.6667 16.7538 9.8012 17.5 7.50001 17.5C5.19882 17.5 3.33334 16.7538 3.33334 15.8333V8.75M11.6667 12.5C11.6667 13.4205 9.8012 14.1667 7.50001 14.1667C5.19882 14.1667 3.33334 13.4205 3.33334 12.5M16.6667 4.58333C16.6667 3.43274 14.8012 2.5 12.5 2.5C10.8508 2.5 9.42531 2.9791 8.75001 3.67414M16.6667 4.58333C16.6667 5.35446 15.8288 6.02774 14.5833 6.38795M16.6667 4.58333V11.6667C16.6667 12.2836 15.8288 12.8222 14.5833 13.1104M16.6667 8.33333C16.6667 8.9639 15.7912 9.51269 14.5 9.79581",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgCoins;
